import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  downloadFile(){
    window.open('./assets/TechPixels_PPT.pdf', '_blank');
  }

}



// WEBPACK FOOTER //
// /home/itheunrealist/techpixels/src/app/header/header.component.ts